import { gatewayPhone } from "../../../../../../../../gateways/gatewayPhone";
import { UsPhoneNumberPricingResponse } from "../interfaces/phone-number-princing.interfaces";



export const getUsPhoneNumberPricing = async (
    phoneNumber: string,
): Promise<UsPhoneNumberPricingResponse> => {
    const response = await gatewayPhone.get<UsPhoneNumberPricingResponse>(
        "/twilio/phone-numbers/us/pricing",
        {
            params: {
                phoneNumber,
            },
        },
    );

    return response.data;
};